import React from 'react'
import './ourhistory.scss'
import { Hero, Sidebar, MainHeading , Breadcrumb , OurHistory , FindAgent} from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
const OurHistoryMain = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "About us", link: "/aboutus" },
    { label: "History", link: "/aboutus/ourhistory" },
  ];
  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];
  return (
    <>
      {/* hero section */}
      <Hero img={images["our-history-hero.avif"]} />
      <Container>
        {/* Breadcrumb */}
        <Breadcrumb crumbs={breadcrumbs}/>
         
        {/* heading  */}
        <MainHeading title="Meeting needs throughout our history"/>

        {/* Layout */}
        <Row>
          <Col sm={12} md={6} lg={8} xl={8}>
            <OurHistory/>
          </Col>
          <Col sm={12} md={6} lg={4} xl={4}>
            <Sidebar />
          </Col>
        </Row>
        <FindAgent options={Selectoptions}/>
      </Container>
    </>
  )
}

export default OurHistoryMain